import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import Badge from 'react-bootstrap/Badge';
import Swal from 'sweetalert2';
import ClientDetails from '../ClientDetails/ClientDetails';
import DenyRequest from '../DenyRequest/DenyRequest';
import AppointTime from '../AppointTime/AppointTime';

const  PendingRequestsRow = (props) => {
  const dispatch = useDispatch();
  const request = useSelector((store) => store.requestReducer.pending);
  const [clientDetails, setClientDetails] = useState({});
  const [requestDetails, setRequestDetails] = useState([]);
  const [denyId, setDenyId] = useState(0);
  const [clientModal, setClientModal] = useState(false);
  const [appointModal, setAppointModal] = useState(false);
    console.log("search" + props.inputEl);
  console.log("search results" + props.searchResults);
  const handleShowAppointModal = () => {
    setAppointModal(true);
  }

  const handleShowClientModal = () => {
    setClientModal(true);
  }

  const [denyModal, setDenyModal] = useState(false);

  const handleShowDenyModal = (id) => {
    setDenyModal(true);
  }


  

  function timeConverter(timestamp) {
    const time = new Date(timestamp);
    const fd = new Intl.DateTimeFormat('en-us').format(time);
    return fd.toString();
  }


  const deleteRequest = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this request',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        dispatch({ type: 'DELETE_REQUEST', payload: id });
        
  
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral NOT deleted'
        )
      }
    })
  }

  const appointTime = async (id) => {
    const foundRequest = await request.filter(r => r.id === id)
    setRequestDetails(foundRequest);
    handleShowAppointModal();
 
  }

  const deny = (id) => {
    console.log('HEY', id);
    setDenyId(id)
    handleShowDenyModal();
  }

   const displayDetails = (client) => {
    setClientDetails(client);
    handleShowClientModal();
  }

  useEffect(() => {
    dispatch({ type: 'FETCH_REQUESTS' });
     dispatch({ type: 'FETCH_NEWEST_REQUESTS' });
    dispatch({ type: 'FETCH_NAME_REQUESTS' });
     dispatch({ type: 'FETCH_CLIENTS' });
  }, []);

  return (
  <>
    <tbody>
      
      <AppointTime
        appointModal={appointModal}
        setAppointModal={setAppointModal}
        handleShowAppointModal={handleShowAppointModal}
        request={requestDetails}
      />
      <DenyRequest
        denyModal={denyModal}
        setDenyModal={setDenyModal}
        handleShowDenyModal={handleShowDenyModal}
        denyId={denyId}
      /> 
      <ClientDetails
        clientModal={clientModal}
        setClientModal={setClientModal}
        client={clientDetails}
      /> 
       {props.searchResults.map(request => (
        <tr key={request.id}>
          <td scope="row" className="text-center px-0 mx-0">{timeConverter(request.referral_date)}</td>
          <td scope="row" className="text-center px-0 mx-0">{request.name}</td>
          <td width="50%" scope="row" className="text-center px-0 mx-0">{request.request_items}</td>
          <td scope="row" className="text-center px-0">
            <Icon.CalendarCheck
              className="mr-1"
              type="button"
              color="green" size={30}
              onClick={() => {
                appointTime(request.id)
              }}
            />
            <Icon.InfoSquare
              className="mx-1"
              type="button"
              color="royalblue" size={30}
              onClick={() => {
                displayDetails(request)
              }}
            />
            <Icon.XSquare
              className="mx-1"
              type="button"
              color="orange" size={30}
              onClick={() => {
                deny(request.id)
              }}
            />
            <Icon.Trash
              className="mx-1"
              type="button"
              color="red" size={30}
              onClick={() => deleteRequest(request.id)}
            />
          </td>
        </tr>
      ))} 
    </tbody>
    </>
  );
}

export default PendingRequestsRow;